"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const GameInput_1 = require("./Core/GameInput");
exports.default = GameInput_1.GameInput;
//# sourceMappingURL=module.js.map